import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  tipoOrigenPacienteList,
  tipoOrigenPacienteListSelectBox,
  tipoOrigenPacienteCreate,
  tipoOrigenPacienteRead,
  tipoOrigenPacienteUpdate,
  tipoOrigenPacienteDelete,  
} = actions;

const tipoOrigenPacienteListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/tipoOrigenPaciente/list.php?paramBusqueda=' + paramBusqueda);      
      
      if (response.status === 200 && response.data.data) {       
        dispatch(tipoOrigenPacienteList(response.data.data));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


const tipoOrigenPacienteCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/tipoOrigenPaciente/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const tipoOrigenPacienteReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/tipoOrigenPaciente/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(tipoOrigenPacienteRead(response.data.data));
          return true;
        }
      } else {
        dispatch(tipoOrigenPacienteRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  tipoOrigenPacienteListAction,
  tipoOrigenPacienteCreateAction,
  tipoOrigenPacienteReadAction,    
};
